module.exports = __webpack_public_path__ + "img/acuriano_michin_children.66f1200c.png";